function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Double Refresh Icon");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "double-refresh-Web-store",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "double-refresh-Hyperice-product-landing-page---PayGo-user-logged-in---Desktop",
  transform: "translate(-772.000000, -1696.000000)",
  stroke: "currentcolor",
  strokeWidth: 0.992248062
}, /*#__PURE__*/React.createElement("g", {
  id: "double-refresh-EFFECTIVE-Copy",
  transform: "translate(-445.000000, 1371.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "double-refresh-Group-12",
  transform: "translate(1218.000000, 326.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.66848318,17.3715158 C0.789981892,15.8375881 0.287871646,14.061421 0.287871646,12.1679671 C0.287871646,6.37645126 4.98317738,1.68114553 10.7754598,1.68114553 C13.1832893,1.68114553 15.4017733,2.49372089 17.1733409,3.85746764",
  id: "double-refresh-Stroke-11"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.6933211,6.64904729 C20.687576,8.25196717 21.2609783,10.1431213 21.2609783,12.1684271 C21.2609783,17.9591764 16.5664391,22.6544821 10.7756898,22.6544821 C8.24750723,22.6544821 5.92860114,21.7606492 4.1194711,20.2719498",
  id: "double-refresh-Stroke-13"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "double-refresh-Stroke-16",
  strokeLinejoin: "round",
  points: "13.3687251 4.63508693 17.1724977 3.88307143 16.4204822 0.0792988573"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "double-refresh-Stroke-18",
  strokeLinejoin: "round",
  points: "4.67761838 23.9194166 4.11878117 20.2827586 7.75543919 19.7231548"
})))));

var SvgDoubleRefresh = function SvgDoubleRefresh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 23 26",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoubleRefresh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/double-refresh.13acb253.svg";
export { ForwardRef as ReactComponent };